import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const EmergencyPopup: React.FC = () => {
  const [show, setShow] = useState(true);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 100, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 100, scale: 0.95 }}
          transition={{ duration: 0.5, type: "spring" }}
          className="fixed bottom-4 right-4 z-50 w-[90vw] max-w-xs sm:max-w-sm shadow-2xl"
        >
          <div className="bg-gradient-to-r from-red-500 to-red-600 p-4 sm:p-6 rounded-xl text-white text-center border-4 border-white/20 relative">
            <button
              onClick={() => setShow(false)}
              className="absolute top-2 right-2 text-white/80 hover:text-white text-lg sm:text-xl font-bold"
              aria-label="Close"
            >
              &times;
            </button>
            <div className="flex flex-col items-center">
              <svg className="w-8 h-8 sm:w-10 sm:h-10 mb-2 sm:mb-3 text-white animate-pulse" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
              </svg>
              <h3 className="text-lg sm:text-xl font-heading font-bold mb-1 sm:mb-2">Medical Emergency?</h3>
              <p className="mb-3 sm:mb-4 text-white/90 text-sm sm:text-base">For immediate medical assistance, please call 911 or visit your nearest emergency room.</p>
              <a
                href="tel:911"
                className="inline-block bg-white text-red-600 font-bold px-4 py-2 sm:px-6 sm:py-3 rounded-lg hover:bg-gray-100 transition-colors shadow text-sm sm:text-base"
              >
                Call 911 Now
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default EmergencyPopup;